import React from 'react';
import PartnerActivitiesPanel from './PartnerActivitiesPanel';
import PartnerAffairsPanel from './PartnerAffairsPanel';
import PartnerDocumentsPanel from './PartnerDocumentsPanel';
import PartnerMetricsPanel from './PartnerMetricsPanel';
import PartnerProjectsPanel from './PartnerProjectsPanel';
import PartnerQuotesPanel from './PartnerQuotesPanel';

const PANELS = {
  affairs: PartnerAffairsPanel,
  projects: PartnerProjectsPanel,
  quotes: PartnerQuotesPanel,
  activities: PartnerActivitiesPanel,
  documents: PartnerDocumentsPanel,
  metrics: PartnerMetricsPanel,
};

export default function PartnerCommercialPanel({ activeTab, loading, overview = {}, onNavigate, contacts, relationshipStatus, activityError, activitySaving, onAddActivity }) {
  const Panel = PANELS[activeTab];
  if (!Panel) return null;
  if (loading) return <section className="partner-section"><p className="partner-empty">Chargement des données commerciales...</p></section>;
  if (activeTab === 'metrics') return <Panel overview={overview} />;
  if (activeTab === 'activities') return <Panel rows={overview.activities || []} contacts={contacts} affairs={overview.affairs || []} relationshipStatus={relationshipStatus} error={activityError} saving={activitySaving} onAdd={onAddActivity} />;
  return <Panel rows={Array.isArray(overview[activeTab]) ? overview[activeTab] : []} onNavigate={onNavigate} />;
}
